/**
 *   Generated file. Do not edit
 */

import { createEnumConverter } from '@iotize/tap/service/core';
import { createEnumArrayConverter } from '@iotize/tap/service/core';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { ArrayConverter } from '@iotize/tap/client/impl';
import { EnumListConverter } from '@iotize/tap/client/impl';
import { AvailablePowerSource } from './models';

export const availablePowerSource = createEnumConverter<AvailablePowerSource>(
  AvailablePowerSource,
  1,
);

export const availablePowerSourceArray =
  createEnumArrayConverter<AvailablePowerSource>(AvailablePowerSource, 1);
